import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const ArrowRightDownLine = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    title="ArrowRightDownLine"
    {...props}
  >
    <path d="M14.5895 16.0032L5.98291 7.39664L7.39712 5.98242L16.0037 14.589V7.00324H18.0037V18.0032H7.00373V16.0032H14.5895Z" />
  </svg>
);
export default React.memo(ArrowRightDownLine);
